import Text from "app/styles/Text";
import tw, { styled } from "twin.macro";

type EventType = "completed" | "confirming" | "detected";

type Props = {
  title: string;
  description?: string;
  date?: string;
  event: EventType;
};

export default function EventActivity({
  title,
  description,
  date,
  event,
}: Props) {
  return (
    <div tw="flex gap-[16px]">
      <EventIndicator event={event} />
      <div>
        <Text semiBold css={[event === "completed" && tw`text-text-mid`]}>
          {title}
        </Text>
        {description && <Text tw="text-text-mid">{description}</Text>}
        {date && (
          <Text small tw="text-text-low mt-[8px]">
            {date}
          </Text>
        )}
      </div>
    </div>
  );
}

const EventIndicator = styled.div<{ event: EventType }>`
  ${tw`w-[2px] h-auto bg-primary rounded-[8px]`}

  ${(props) => props.event === "confirming" && tw`bg-[#F0B638]`};

  ${(props) => props.event === "completed" && tw`bg-[#B8C2B8]`};
`;
